import styled from 'styled-components';

export const FulfilmentCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
`;

const HoldCountdownPillWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f0f2f5;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #232d3a;
  white-space: nowrap;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #12b76a;
    flex: 0 0 auto;
  }

  strong {
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    /* Fixed width: the digits change width as they tick, which re-laid out the
       whole orders table every second. */
    display: inline-block;
    width: 3.2em;
  }
`;

export default HoldCountdownPillWrap;
